/**
 *** Авторизация
 * */

import Validate from "./Validate";
import {scrollToElement} from "./Util";

//const $regForm = $('.js-reg-sms-request');
const $registrationTestsWrapper = $('.js-registration-tests-wrapper');
const $registrationTestsFail = $('.js-registration-tests-fail');
const $registrationTestsFailAnswer = $('.js-registration-tests-fail-answer');
const $smsRequest = $('.js-form-sms-request');
const $smsSend = $('.js-form-sms-send');
const $smsPhone = $('.js-form-sms-phone');
const $smsResendBtn = $('.js-sms-resend-btn');
//const $regButton = $('.js-reg-button');
const $registrationForm = $('.js-registration-form');
const registrationFormAnswers = $registrationForm.data('answer') ?  $registrationForm.data('answer') : 1;
let currAnswersCount = 0;
let wrongAnswers = 0;
const $regFormWrap = $('.js-reg-form-wrap');
const $phone = $('.js-mask-phone', $smsRequest);
const smsResendDeration = 10;
const maxWrongQuestion = 3;
let groupQuestion = 1;
let groupQuestionArr = [];
let smsResendTimer;
let phone = $phone.val();

export function showSmsSend() {
    $smsRequest.addClass('_hidden');
    $smsSend.removeClass('_hidden');
    $smsResendBtn.attr('disabled', true).trigger('start');
}

export function showSmsRequest() {
    $smsRequest.removeClass('_hidden');
    $smsSend.addClass('_hidden');
}

$smsResendBtn.on('click start', function (e) {
    if (smsResendTimer) return;
    if (e.type == 'click') smsRrequest();
    $smsResendBtn.attr('disabled', true);
    smsResendTimer = setTimeout(function () {
        $smsResendBtn.attr('disabled', false);
        clearTimeout(smsResendTimer);
        smsResendTimer = null;
    }, smsResendDeration * 1000);
});

export function smsRrequest() {
    $('[data-sms-confirmed-form]').removeClass('phone-is-accept');
    $smsRequest.find('input[type="text"]').attr('disabled', false);
    $smsRequest.find('.ajax-error').html('');

    $.ajax({
        url: $smsRequest.attr('action'),
        method: $smsRequest.attr('method') || 'GET',
        data: {
            //phone: phone,
            phone: $('.js-sms-phone-field').val(),
            "g-recaptcha-response": App.currentRecaptcha
        },
        success: (response) => {
            if (response.success) {
                $('.js-form-sms-send').find('.ajax-error').html('');
                //$('[data-sms-confirmed-form]').find('.js-submit').trigger('click');
            } else {
                $smsRequest.find('input[type="text"]').attr('disabled', true);
                $smsRequest.find('.ajax-error').html(response.message);
                console.log(response.message || 'Ошибка от сервера');
                $('.js-form-sms-send').find('.ajax-error').html(response.message);
            }
        },
        error: () => {
            console.log('Ошибка получения данных');
        }
    });
}

export function regAfterCheckingPhone(form) {
    form.closest('.js-common-popup').find('.js-common-popup-close').trigger('click');
    $registrationForm.find('.js-submit').trigger('click');
}

$phone.on('change', function () {
    if ($phone.val()) phone = $phone.val();
    $smsPhone.val($phone.val());
});


/*$regButton.on('click', function (e) {
    if ($registrationForm.find('._error, ._notvalidated').length === 0 && $registrationForm.find('.js-mask-phone').val() !== '') {
        // Если каптча в форме регистрации есть и она пустая, то значит она истекла, показываем сообщение, что надо пройти ее снова
        if ($registrationForm.find('.js-recaptcha').length && grecaptcha.getResponse().length === 0) {
            $registrationForm.find('.js-recaptcha').addClass('_error');
            scrollToElement($registrationForm.find('.js-recaptcha'));
            return false;
        }

        phone = $registrationForm.find('.js-mask-phone').val();
        smsRrequest();
        $registrationForm.find('.js-check-phone').trigger('click');
    } else {
        $registrationForm.find('.js-submit').trigger('click');
        return false;
    }

    e.preventDefault();
});*/

//

$('.js-reg-form-btn').on('click', function (e) {
    let currStep = $(this).data('step');
    let tempValid = new Validate();
    let $stepFields = $regFormWrap.find(`.reg-form-step[data-step=${currStep - 1}]`).find('[data-required]');

    if (!$(this).hasClass('_prev')) {
        $stepFields.each(function () {
            let $currField = $(this);

            tempValid.validateField($currField);
        });

        if ($stepFields.filter('._error, ._notvalidated').length === 0) {
            $regFormWrap.attr('data-step', currStep);
            scrollToElement($regFormWrap);
        } else {
            scrollToElement($stepFields.filter('._error').first());
        }
    } else {
        $regFormWrap.attr('data-step', currStep);
        scrollToElement($regFormWrap);
    }

    e.preventDefault();
});

export function activateTestForRegistration() {
    if ($registrationForm.is('[data-group-answer]')) {
        $registrationForm.find('.js-questions-item').addClass('_showen');

        $registrationForm.find('.js-questions-item').each(function () {
            groupQuestionArr.push($(this).data('id'));
        });

        $('.js-registration-tests-questions').val(groupQuestionArr.join('-'));
    }
}

/* Регистрация для специалистов: 3-ий шаг с тестом */
if ($registrationTestsWrapper.length) {
    let currRegQuestion = 0;
    const regAttempt = 3;

    $('.js-registration-next-group-questions').on('click', function (e) {
        $registrationTestsWrapper.show();
        $registrationTestsFailAnswer.hide();
        $registrationTestsFail.hide();
        scrollToElement($registrationTestsWrapper);

        e.preventDefault();
    });

    /* Проверка групповых ответов теста при основной регистрации */
    $('.js-registration-check-group-btn').on('click', function (e) {
        const $currTestsWrap = $(this).closest('.js-tests-wrapper');
        const $currTestsError = $currTestsWrap.find('.js-tests-wrapper-error');
        const rightAnswersCount = $currTestsWrap.find('.questions-item__answer-item._checked._success').length;
        const answeredQuestionsCount = $currTestsWrap.find('.questions-item__answer-item._checked').length;
        const questionCount = $currTestsWrap.find('.js-questions-item').length;

        // если ответили на все вопросы
        if (answeredQuestionsCount === questionCount) {
            $currTestsError.removeClass('_showen');

            // если на все вопросы отвечено верно, то отправляем форму, иначе показываем следующую порцию вопросов
            if (rightAnswersCount === questionCount) {
                $registrationForm.submit();
            } else {
                let rightAnswers = '';

                $currTestsWrap.find('.js-questions-item._showen').each(function () {
                    let $currQuestion = $(this);
                    let currRightAnswer = `<li>${$currQuestion.find('.questions-item__title').html()} — <b>${$currQuestion.find('.questions-item__answer-item._success').find('.js-variant-text').html()}</b></li>`;

                    rightAnswers += currRightAnswer;
                });

                $('.js-registration-fail-answer-text').html(`
                    <ul>${rightAnswers}</ul>
                `);

                $('.js-registration-tests-answer-count').html(maxWrongQuestion - groupQuestion);
                $registrationTestsWrapper.hide();
                $registrationTestsFailAnswer.show();
                $registrationTestsFail.hide();
                scrollToElement($registrationTestsFailAnswer);

                $('.js-start-test').trigger('click');

                groupQuestion++;

                if (groupQuestion > 3) {
                    $registrationTestsFailAnswer.hide();
                    $registrationTestsFail.show();

                    // если все попытки исчерпаны, то ставим куку на сутки
                    document.cookie = "go_away=yes; max-age=86400";
                }
            }
        } else {
            $currTestsError.addClass('_showen');
            scrollToElement($currTestsError);
        }

        e.preventDefault();
    });

    /* Проверка ответов теста при регистрации */
    $('.js-registration-check-btn').on('click', function (e) {
        const $currAnswer = $registrationTestsWrapper
            .find('.js-questions-item._showen')
            .find('.questions-item__answer-item._checked');

        if ($currAnswer.is('._success')) {
            currAnswersCount++;

            if (currAnswersCount === registrationFormAnswers) {
                $registrationForm.submit();
            } else {

                currRegQuestion++;
                $registrationTestsWrapper.find('.js-questions-item').removeClass('_showen')
                    .eq(currRegQuestion).addClass('_showen');
            }
        } else {
            let rightAnswer = $registrationTestsWrapper.find('.js-questions-item._showen').find('.questions-item__answer-item._success').find('.js-variant-text').html();

            currRegQuestion++;
            wrongAnswers++;
            regShowNextQuestion(rightAnswer, regAttempt, wrongAnswers, currRegQuestion);
        }

        e.preventDefault();
    });

    $('.js-registration-next-question').on('click', function (e) {
        $registrationTestsWrapper.find('.js-questions-item').removeClass('_showen')
            .eq(currRegQuestion).addClass('_showen');

        $registrationTestsFailAnswer.hide();
        $registrationTestsWrapper.show();

        e.preventDefault();
    });
}

/* показываем следующий вопрос из списка вопросов (для регистрации) */
function regShowNextQuestion(rightAnswerIndex, regAttemptIndex, wrongAnswersIndex, currRegQuestionIndex) {
    $('.js-registration-fail-answer-text').html(rightAnswerIndex);
    $('.js-registration-tests-answer-count').html(regAttemptIndex - currRegQuestionIndex);
    $registrationTestsWrapper.hide();
    $registrationTestsFailAnswer.hide();
    $registrationTestsFail.hide();

    if (wrongAnswersIndex < maxWrongQuestion) {
        $registrationTestsFailAnswer.show();
    } else {
        $registrationTestsFail.show();

        // если все попытки исчерпаны, то ставим куку на сутки
        document.cookie = "go_away=yes; max-age=86400";
    }
}
